export default "__VITE_ASSET__sHPMzsI1__"